
export const initState = <T>(): State<T>  => {
  let stateStr = sessionStorage.getItem('state')
  
  return stateStr ?JSON.parse(stateStr) : {
    list: [],
    paging: {
      current: 1,
      total: 0,
      number: 0
    }
  }
}